import type { InplaceDesignTokens, InplaceTokenSections } from '@primeuix/themes/types/inplace';

export const root: InplaceTokenSections.Root = {
    padding: '{formField.paddingY} {formField.paddingX}',
    borderRadius: '{content.borderRadius}',
    focusRing: {
        width: '{focusRing.width}',
        style: '{focusRing.style}',
        color: '{focusRing.color}',
        offset: '{focusRing.offset}',
        shadow: '{focusRing.shadow}'
    },
    transitionDuration: '{transitionDuration}'
};

export const display: InplaceTokenSections.Display = {
    hoverBackground: '{content.hoverBackground}',
    hoverColor: '{content.hoverColor}'
};

export default {
    root,
    display
} satisfies InplaceDesignTokens;
